import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TeamRolloffData, TeamRolloffRow } from '../../../interfaces/metrics';

@Component({
  selector: 'bst-team-rolloff-table',
  templateUrl: './team-rolloff-table.component.html',
  styleUrls: ['./team-rolloff-table.component.scss'],
  standalone: false,
})
export class TeamRolloffTableComponent {
  @Input() data!: TeamRolloffData;
  @Output() memberSelected = new EventEmitter<{ userId: number; name: string }>();

  pick(row: TeamRolloffRow): void { this.memberSelected.emit({ userId: row.userId, name: row.name }); }
}
